<template>
<b-form @submit="editRate">
  <b-alert show v-if="!!rateAlert" :variant="rateAlert.variant">{{ rateAlert.text }}</b-alert>

  <section v-if="itAccess || !newRate">
    <b-row class="justify-content-center align-items-center my-1">
      <b-col>
        <label for="rateCarrierName">Carrier Name</label>
        <b-form-input required name="rateCarrierName" type="text" v-model="data.carrier" :disabled="!newRate || !itAccess" />
      </b-col>
      <b-col>
        <label for="rateServiceName">Service Name</label>
        <b-form-input required name="rateServiceName" type="text" v-model="data.service" :disabled="!newRate || !itAccess" />
      </b-col>
    </b-row>

    <b-row class="justify-content-center align-items-center my-1">
      <b-col>
        <label for="rateDisplayName">Display Name</label>
        <b-form-input name="rateDisplayName" type="text" v-model="data.displayName" :disabled="!itAccess" />
      </b-col>
    </b-row>

    <b-row class="justify-content-center align-items-center my-1">
      <b-col>
        <label for="rateActive">Active</label>
        <b-form-checkbox switch name="rateActive" v-model="data.active" :disabled="!itAccess" />
      </b-col>
      <b-col>
        <label for="rateForced">Forced</label>
        <b-form-checkbox switch name="rateForced" v-model="data.forced" :disabled="!itAccess" />
      </b-col>
      <b-col>
        <label for="hazmatAllowed">Allow Hazardous Materials?</label>
        <b-form-checkbox switch name="hazmatAllowed" v-model="data.hazmatAllowed" />
      </b-col>
      <b-col>
        <label for="RateSaturdayDelivery">Allow Saturday Delivery?</label>
        <b-form-checkbox switch name="rateSaturdayDelivery" v-model="data.saturdayDelivery" :disabled="!itAccess" />
      </b-col>
    </b-row>

    <b-row class="justify-content-center align-items-center my-1" v-if="data.saturdayDelivery">
      <b-col>
        <label for="prettyTimebandStartDay">Saturday Delivery Timeband Start</label>
        <b-form-select name="prettyTimebandStartDay" :options="dayOptions" v-model="data.saturdayDeliveryStartDay" :disabled="!itAccess" />
        <b-form-select name="prettyTimebandStartHour" :options="hourOptions" v-model="data.saturdayDeliveryStartHour" :disabled="!itAccess" />
      </b-col>
      <b-col>
        <label for="prettyTimebandEndDay">Saturday Delivery Timeband End</label>
        <b-form-select name="prettyTimebandEndDay" :options="dayOptions" v-model="data.saturdayDeliveryEndDay" :disabled="!itAccess" />
        <b-form-select name="prettyTimebandEndHour" :options="hourOptions" v-model="data.saturdayDeliveryEndHour" :disabled="!itAccess" />
      </b-col>
    </b-row>

    <b-row class="justify-content-center align-items-center my-1">
      <b-col>
        <label for="rateCalculationMode">Calculation Mode</label>
        <b-form-select required name="rateCalculationMode" :options="calculator_options" v-model="data.calculator" :disabled="!itAccess" />
      </b-col>
      <b-col v-if="showX">
        <label for="rateCalculationX">Calculation X</label>
        <b-form-input name="rateCalculationX" step="0.01" type="number" v-model="data.calculatorX" :disabled="!itAccess" />
      </b-col>
      <b-col v-if="showY">
        <label for="rateCalculationY">Calculation Y</label>
        <b-form-input name="rateCalculationY" step="0.01" type="number" v-model="data.calculatorY" :disabled="!itAccess" />
      </b-col>
    </b-row>

  <b-row>
    <b-col>
      <label for="rateMaxDimension">Maximum Dimension (inches)</label>
      <b-form-input name="rateMaxDimension" step="0.01" type="number" v-model="data.maxDimension" :disabled="!itAccess" />
    </b-col>
    <b-col>
      <label for="rateMaxWeightLbs">Maximum Weight (pounds)</label>
      <b-form-input name="rateMaxWeightLbs" step="0.01" type="number" v-model="data.maxWeightLbs" :disabled="!itAccess" />
    </b-col>
    <b-col>
      <label for="rateMaxOrderValueDollars">Maximum Order Value ($)</label>
      <b-form-input name="rateMaxOrderValueDollars" step="0.01" type="number" v-model="data.maxOrderValueDollars" :disabled="!itAccess" />
    </b-col>
  </b-row>

    <hr />
    <b-row class="justify-content-center align-items-center mt-2">
      <b-col>
        <label for="rateCountries">Allowed Countries</label>
        <b-form-input name="rateCountries" v-model="data.countries" :disabled="!itAccess" />
      </b-col>
      <b-col>
        <label for="rateRegions">Allowed Regions</label>
        <b-form-input name="rateRegions" v-model="data.regions" :disabled="!itAccess" />
      </b-col>
    </b-row>
    <b-row class="justify-content-center align-items-center mb-2">
      <b-col>
        <label for="rateNotCountries">Disallowed Countries</label>
        <b-form-input name="rateNotCountries" v-model="data.notCountries" :disabled="!itAccess" />
      </b-col>
      <b-col>
        <label for="rateNotRegions">Disallowed Regions</label>
        <b-form-input name="rateNotRegions" v-model="data.notRegions" :disabled="!itAccess" />
      </b-col>
    </b-row>
  </section>

  <b-row class="justify-content-center align-items-center mt-2 mb-1" v-if="itAccess">
    <b-col cols="*">
      <b-btn type="submit" variant="warning">
        <i class="fas fa-fw fa-user-lock"></i>
        Submit
      </b-btn>
    </b-col>
  </b-row>
  <b-row class="justify-content-center align-items-center mt-2 mb-1" v-else>
    <b-col cols="*">
      <b-alert variant="warning" show>
        <center>
          Creating/Editing Rates is restricted. If you believe you should have access to this functionality, ask IT for access!
        </center>
      </b-alert>
    </b-col>
  </b-row>
</b-form>
</template>

<script>
const BASE_API = process.env.VUE_API_ROOT;
import axios from 'axios';

export default {
  data() {
    return {
      calculator_options: [
        { value: 'flat-fee', text: 'Flat Fee ($X)', showX: true },
        { value: 'retail-rate', text: 'Retail Rate +/- X%', showX: true },
        { value: 'our-rate', text: 'Our Rate +/- X%', showX: true },
        { value: 'split-difference', text: 'Split Difference between Retail/Discount Rates +/- X% of difference', showX: true },
        { value: 'weight-based', text: '$X + ($Y * Shipment Weight in Pounds)', showX: true, showY: true },
        { value: 'x-off-retail', text: 'X% off Retail, minimum Y% above Our Rate', showX: true, showY: true },
      ],
      rateAlert: undefined,
      dayOptions: [...Array(8).keys()].map(x => ({ value: x-1, text: this.prettyDay(x-1) })),
      hourOptions: [...Array(25).keys()].map(x => ({ value: x-1, text: this.prettyHour(x-1) })),
    };
  },
  props: {
    newRate: { type: Boolean, default: false },
    data: { type: Object, default: () => ({
      active: false,
      forced: false,
      hazmatAllowed: true,
      saturdayDelivery: false,
      saturdayDeliveryStartDay: -1,
      saturdayDeliveryStartHour: -1,
      saturdayDeliveryEndDay: -1,
      saturdayDeliveryEndHour: -1,
      calculator: 'flat-fee',
      calculatorX: 0,
      calculatorY: 0,
      countries: '',
      regions: '',
      notCountries: '',
      notRegions: '',
      maxDimension: 0,
      maxWeightLbs: 0,
      maxOrderValueDollars: 0,
    }) },
  },
  computed: {
    itAccess() {
      return this.$store.getters.canAccess('it-staff')
    },
    showX() {
      let calculator = this.data.calculator;
      if (!calculator || calculator == '') return false;
      return this.calculator_options.filter(x => x.value === calculator)[0].showX
    },
    showY() {
      let calculator = this.data.calculator;
      if (!calculator || calculator == '') return false;
      return this.calculator_options.filter(x => x.value === calculator)[0].showY
    },
  },
  methods: {
    prettyTimeband(startDay, startHour, endDay, endHour) {
      let tb = ""

      let day = this.prettyDay(startDay)
      let day2 = this.prettyDay(endDay)
      let multiDay = day !== day2
      let multiHour = startHour !== endHour

      if (multiDay && multiHour) {
        return `${day} ${this.prettyHour(startHour)} — ${day2} ${this.prettyHour(endHour)}`
      } else if (multiDay) {
        return `${day} — ${day2}`
      } else if (multiHour) {
        return `${day} ${this.prettyHour(startHour)} — ${this.prettyHour(endHour)}`
      } else {
        return ""
      }
    },
    prettyDay(day) {
      switch(day) {
        case -1: return 'Any Day'
        case  0: return 'Sunday'
        case  1: return 'Monday'
        case  2: return 'Tuesday'
        case  3: return 'Wednesday'
        case  4: return 'Thursday'
        case  5: return 'Friday'
        case  6: return 'Saturday'
        default: return '???????'
      }
    },
    prettyHour(hour) {
      if (hour < 0) return 'Any Hour'

      let pm = hour > 11
      if (pm) hour -= 12
      if (!hour) hour = 12

      return `${String(hour).padStart(2, '0')}:00 ${pm ? 'PM' : 'AM'}`
    },
    editRate(event)
    {
      if (!!event) {
        event.preventDefault();
      }
      this.rateAlert = undefined;

      if (this.showX && this.data.calculatorX.length === 0 || isNaN(this.data.calculatorX)) {
        this.rateAlert = { variant: 'danger', text: 'Calculator X must be set to a number'}
        return
      } else if (this.showY && this.data.calculatorY.length === 0 || isNaN(this.data.calculatorY)) {
        this.rateAlert = { variant: 'danger', text: 'Calculator Y must be set to a number'}
        return
      } else if (this.data.regions !== "" && this.data.countries === "") {
        this.rateAlert = { variant: 'danger', text: 'Country restrictions must be set if Region restrictions are set!' }
        return
      } else if (this.data.notRegions !== "" && this.data.notCountries === "") {
        this.rateAlert = { variant: 'danger', text: 'Disallow Country restrictions must be set if Disallow Region restrictions are set!' }
        return
      } else if ((this.data.notRegions !== "" || this.data.notCountries !== "") && (this.data.regions !== ""  || this.data.countries !== "")) {
        this.rateAlert = { variant: 'danger', text: 'Either Disallow Countries/Regions or Allow Countries must be blank!'}
      } else if (!!this.data.forced && !['flat-fee', 'weight-based'].includes(this.data.calculator)) {
        this.rateAlert = { variant: 'danger', text: '"Forced" rates must either have "Flat Fee" or "Weight-Based" calculation!' }
        return
      } else if (!!this.data.maxDimension && Number(this.data.maxDimension) < 0) {
        this.rateAlert = { variant: 'danger', text: 'Maximum dimension must be greater than 0!' }
      } else if (!!this.data.maxWeightLbs && Number(this.data.maxWeightLbs) < 0) {
        this.rateAlert = { variant: 'danger', text: 'Maximum weight must be greater than 0!' }
      } else if (!!this.data.maxOrderValueDollars && Number(this.data.maxOrderValueDollars) < 0) {
        this.rateAlert = { variant: 'danger', text: 'Maximum order value must be greater than 0!' }
      }

      if (this.data.saturdayDelivery) {
        if (this.data.saturdayDeliveryStartDay === -1) this.data.saturdayDeliveryStartDay = null
        if (this.data.saturdayDeliveryStartHour === -1) this.data.saturdayDeliveryStartHour = null
        if (this.data.saturdayDeliveryEndDay === -1) this.data.saturdayDeliveryEndDay = null
        if (this.data.saturdayDeliveryEndHour === -1) this.data.saturdayDeliveryEndHour = null
      } else {
        this.data.saturdayDeliveryStartDay = null
        this.data.saturdayDeliveryStartHour = null
        this.data.saturdayDeliveryEndDay = null
        this.data.saturdayDeliveryEndHour = null
      }

      if (!this.data.displayName || this.data.displayName == "") {
        this.data.displayName = `${this.data.carrier} ${this.data.service}`;
        console.log(this.data.displayName)
      }

      if (isNaN(this.data.maxDimension) || Number(this.data.maxDimension) == 0) {
        this.data.maxDimension = null
      }
      if (isNaN(this.data.maxWeightLbs) || Number(this.data.maxWeightLbs) == 0) {
        this.data.maxWeightLbs = null
      }
      if (isNaN(this.data.maxOrderValueDollars) || Number(this.data.maxOrderValueDollars) == 0) {
        this.data.maxOrderValueDollars = null
      }

      let promise = undefined;
      if (this.newRate) {
        promise = axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/aws/dynamo/shipping-rates/put`,
          data: this.data,
        });
      } else {
        promise = axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/aws/dynamo/shipping-rates/edit`,
          data: this.data,
        });
      }

      promise.then(() => {
        this.rateAlert = { variant: "success", text: 'Rate updated successfully!' }
      }).catch(error => {
        this.rateAlert = { variant: "danger", text: 'Rate failed to update! Check console for details' }
        console.error(error)
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ops-info/RateForm.vue